import { gql } from '@apollo/client';

export default gql`
  mutation deleteGeneralDoc($_id: String) {
    deleteGeneralDoc(_id: $_id) {
      ok
      message
      error
    }
  }
`;
